import { SkeletonProvider } from './SkeletonProvider';
export class StubHubProvider extends SkeletonProvider { constructor() { super({ id: 'stubhub', name: 'StubHub', authStrategy: 'oauth2', documentationUrl: 'https://developer.stubhub.com/' }); } }
